// extracted by mini-css-extract-plugin
export default {"input":"styles_input__5PoV6","icon":"styles_icon__a-kIM"};